export enum DeepLinkTypes {
  authBySberIDApp = 'authBySberIDApp',
  authBySberIDWeb = 'authBySberIDWeb'
}

export enum SourcesTypes {
  sbolEr = 'sbolEr',
  sberPrime = 'sberPrime'
}
